import {getMedia} from 'shared/mq';
import PropTypes from 'prop-types';
import {find} from 'lodash';
import {zonedTimeToUtc} from 'date-fns-tz';

export const shortCollegeName = (name, nickname, isEarning) => {
  if (getMedia().LG) return name;

  // no earnings = more space for the name
  let maxCharsToDisplay = isEarning ? 25 : 30;
  if (getMedia().SM || getMedia().MD) {
    maxCharsToDisplay = 15;
  }
  let displayableName = name;
  if (displayableName.length > maxCharsToDisplay && nickname) {
    displayableName = nickname;
  }
  // Prevent multiple "University of ..."
  if (displayableName.length > maxCharsToDisplay) {
    displayableName = displayableName.replace(/^university/i, 'U');
  }
  if (displayableName.length > maxCharsToDisplay) {
    displayableName = displayableName.substring(0, maxCharsToDisplay - 3) + '...';
  }
  return displayableName;
};

export const EARNINGS_PROP_TYPES = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  divisor: PropTypes.number.isRequired,
  earningRelationship: PropTypes.shape({
    statusType: PropTypes.string.isRequired,
  }).isRequired,
  nickname: PropTypes.string,
  amount: PropTypes.number,
  admissionLikelihoodScoreCategory: PropTypes.string,
  maxEarnings: PropTypes.number,
  useApplyByTerminology: PropTypes.bool,
};

export const getEndDate = (term) => {
  const now = new Date();
  const currentYear = now.getFullYear();

  const endDate = new Date(currentYear, term.endMonth - 1, term.endDay);
  const today = new Date(currentYear, now.getMonth(), now.getDate());

  if (endDate < today) {
    endDate.setFullYear(currentYear + 1);
  }

  return endDate;
};

export const getSchoolYearStartYear = (terms) => {
  const currentYear = new Date().getFullYear();
  const currentTerm = find(terms, {current: true});

  if (!currentTerm) {
    return currentYear;
  }

  return getEndDate(currentTerm).getFullYear() - currentTerm.yearDelta;
};

/**
 * Calculates the number of days left from local time to the given submission deadline.
 *
 * @param deadlineYear 4 digit year (Not 3000, the actual year)
 * @param deadlineMonth Calendar month (1-indexed)
 * @param deadlineDay
 * @returns {number} The number of days left to the deadline, if the deadline is today then 0 is returned
 */
export const daysToDeadline = (deadlineYear, deadlineMonth, deadlineDay) => {
  // NB: The deadline date in mongo has no time component so it defaults to 00:00,
  // However, the actual deadline (when we process submissions) is at midnight PST on that day
  const deadlineDateUtc = zonedTimeToUtc(
    new Date(deadlineYear, deadlineMonth - 1, deadlineDay, 23, 59, 59),
    'America/Los_Angeles'
  );
  const milliSecondsToDeadline = deadlineDateUtc.valueOf() - new Date().valueOf(); // new Date() will be local time stored internally as Utc
  return Math.floor(milliSecondsToDeadline / (60 * 60 * 24 * 1000));
};
